import { NO_THREADS } from './NO_THREADS.js'

export function resolveAppShellHomeNav({ activePrimaryKey, threads, pinnedThreadIdsForNav }) {
  const homeThreads = activePrimaryKey === 'home' ? threads : NO_THREADS
  const homePinnedIds = activePrimaryKey === 'home' ? pinnedThreadIdsForNav : NO_THREADS
  return { homeThreads, homePinnedIds }
}
